import { Booking } from "../../../../APIDocs/apiTypes"
import { CollapsibleCard } from "../../components/CollapsibleCard";
import { Label } from "../../components/Label";

interface UpdateDetailsProps {
    booking: Booking
    disableCollapse?: boolean
}

export const UpdateDetailsCard = ({ booking, disableCollapse }: UpdateDetailsProps) => {
    return (
        <CollapsibleCard identifier="updateDetails" title="Update Details" disableCollapse={disableCollapse}>
            <Label title="Last Updated By" text={booking.LastUpdatedBy} />
            <Label title="Update Source" text={booking.UpdateSource} />
        </CollapsibleCard>
    )
}
